import { create } from 'zustand';
import { getCategorieForm, type CategoriaForm } from '../api/settings';

interface CategorieState {
  categorie: CategoriaForm[];
  isLoading: boolean;
  loaded: boolean;
  error: boolean;
  fetch: () => Promise<void>;
}

// Store condiviso: le categorie attive vengono caricate UNA sola volta e riusate
// in tutte le pagine/componenti (nessun rifetch multiplo nella stessa pagina).
export const useCategorieStore = create<CategorieState>((set, get) => ({
  categorie: [],
  isLoading: false,
  loaded: false,
  error: false,
  fetch: async () => {
    // già caricate o fetch in corso -> non rifetchare
    if (get().loaded || get().isLoading) return;
    set({ isLoading: true, error: false });
    try {
      const categorie = await getCategorieForm();
      set({ categorie, isLoading: false, loaded: true });
    } catch {
      set({ isLoading: false, error: true });
    }
  },
}));
